// FILE: src/shared/lib/region-slug-dictionary.ts
// VERSION: 2.0.0
// ============================================================================
// CONTRACT:
// PURPOSE: Полный статический словарь slug↔регион для middleware и роутинга.
//          Не требует обращения к БД — безопасен для Edge Runtime middleware.
// SCOPE: [rating, middleware, sitemap, slug]
// KEYWORDS: [REGION(X): dictionary, slug, static, edge, middleware]
// LINKS: [USED_BY(region-utils.ts): slugToRegion(); USED_BY(/rating/[region]): generateStaticParams]
// ============================================================================
// NOTE: Сгенерирован из PROD БД 2026-06-18. Топ-15 регионов по количеству ЧОП.
//       Команда: SELECT region_slug, region, count(*) FROM seo_companies
//       WHERE region_slug IS NOT NULL GROUP BY region_slug, region ORDER BY count(*) DESC LIMIT 30;
// ============================================================================

/** Slug → нормализованное имя региона */
export const REGION_SLUG_DICTIONARY: Record<string, string> = {
  'moskva': 'Москва',
  'moskovskaya': 'Московская область',
  'sankt-peterburg': 'Санкт-Петербург',
  'sverdlovskaya': 'Свердловская область',
  'krasnodarskiy': 'Краснодарский край',
  'samarskaya': 'Самарская область',
  'nizhegorodskaya': 'Нижегородская область',
  'bashkortostan': 'Башкортостан',
  'tatarstan': 'Татарстан',
  'chelyabinskaya': 'Челябинская область',
  'novosibirskaya': 'Новосибирская область',
  'khabarovskiy': 'Хабаровский край',
  'volgogradskaya': 'Волгоградская область',
  'rostovskaya': 'Ростовская область',
  'khanty-mansiyskiy-avtonomnyy-okrug-yugra': 'Ханты-Мансийский автономный округ — Югра',
};

/** Топ-15 slug'ов для generateStaticParams в /rating/[region] */
export const TOP_REGION_SLUGS: string[] = Object.keys(REGION_SLUG_DICTIONARY);


// NOTE: regionNameToSlug удалена — не использовалась нигде. Обратный поиск — через regionToSlug() из region-utils.ts
